import styled from 'styled-components';
import colors from 'constants/colors';

export const Container = styled.div`
  width: 100%;
  min-height: 100%;
  justify-content: center;
  text-align: center;
  padding: 24px;

  .title {
    color: ${colors.white};
    font-size: 22px;
    font-weight: 600;
    margin: 16px 0 0 0; 
  }

  .text {
    color: ${colors.white};
    font-size: 18px;
    font-weight: 600;
    margin: 16px; 
  }

  .buttonContainer {
    display: flex;
    justify-content: center;
    column-gap: 16px;
    margin-top: 24px;
  }
`;
